import React from 'react';

export const Loading = () => {
  return (
    <li>
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </li>
  );
};
